import { useTranslation } from "react-i18next";
import CaseStudyOverview from "./caseStudyOverview";
import { Box, Stack } from "@mui/material";

const CaseStudyCrossIndustries = ({data}) => {
    const {t} = useTranslation();

    return (
        <>
            <Box
                sx={{
                    px: {xs: 2, md: 0},
                    py: {xs: 2, md: 5}
                }}
            >
                <CaseStudyOverview 
                    title={t('caseStudies.crossIndustry')}
                    data={data}
                    leftPanelMdSize={4}
                />
            </Box>
        </>
    );
}

export default CaseStudyCrossIndustries;